import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addNewClient,
  fetchClientDetails,
  fetchRecentVoyages,
} from "../../apis/clientFormUpdate";
import axiosServices from "../../utils/axios";

import type { clientDetails } from "../../utils/types/type-helper";

export const fetchClientDetailsData = createAsyncThunk(
  "clientDetails/fetchClientDetails",
  async (id: string, { rejectWithValue }) => {
    try {
      const ClientDetail = await fetchClientDetails(id);
      return ClientDetail;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);

export const updateClientDetailsData = createAsyncThunk<
  clientDetails, // The type of data that will be returned
  { id: string; data: Partial<clientDetails> }, // The parameters passed to the thunk
  { rejectValue: string } // Type for error handling
>("clientDetails/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await axiosServices.put<clientDetails>(
      `/jobs/${id}`,
      data,
      {
        params: { jobId: id },
      }
    );
    return response.data;
  } catch (error: any) {
    // Extract meaningful error message
    let errorMessage = "Failed to update client details";

    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.response?.data?.error) {
      errorMessage = error.response.data.error;
    } else if (error.message) {
      errorMessage = error.message;
    } else if (error.response?.status) {
      errorMessage = `Server error (${error.response.status})`;
    }

    return rejectWithValue(errorMessage);
  }
});

// Add new client thunk
export const addClientDetailsData = createAsyncThunk(
  "jobs/addNewClient",
  async (_, { rejectWithValue }) => {
    try {
      const response = await addNewClient();
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response || "Failed to add new client.");
    }
  }
);

export const fetchRecentVoyagesData = createAsyncThunk(
  "jobs/fetchRecentVoyages",
  async (vesselId: string, { rejectWithValue }) => {
    try {
      return await fetchRecentVoyages(vesselId);
    } catch (error: any) {
      return rejectWithValue(
        error.response || "Failed to fetch recent voyages."
      );
    }
  }
);
